module.exports = __webpack_public_path__ + "static/logo-desktop-1d3af5f52d913e0ece0053c3956a7074.png";